import { configureStore } from '@reduxjs/toolkit';
import CheckoutSlice from './Reducers/CheckoutSlice';
import auth from './Reducers/auth';
export const store = configureStore({
  reducer: {
    CheckoutSlice: CheckoutSlice,
    auth: auth,
  },
});
